import TapInput from "./TapInput";

export default TapInput;
